import { Endereco } from "./Endereco.ts";
import { Pessoa } from "./Pessoa.ts";

export class Medico extends Pessoa {
  crm: string;
  endereco: Endereco;

  constructor(
    id = 0,
    nome = "",
    email = "",
    telefone = "",
    crm = "",
    endereco: Endereco
  ) {
    super(id, nome, email, telefone);
    this.crm = crm;
    this.endereco = endereco || new Endereco();
  }
}
